'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var locale = {
  placeholder: '请选择时间'
};

exports['default'] = locale;


//////////////////
// WEBPACK FOOTER
// ./node_modules/_ant-design-vue@1.7.8@ant-design-vue/lib/time-picker/locale/zh_CN.js
// module id = 7sWB
// module chunks = 16